import React from 'react';
import { useHistory } from 'react-router-dom';
import App from '@app';
import { Body, PageHeader, AddButton } from '@components';
import TableClientes from './TableClientes';

export default function Clientes() {
  const history = useHistory();

  return (
    <App>
      <Body>
        <PageHeader
          title="Clientes"
          extra={[
            <AddButton
              key="1"
              type="primary"
              tooltipTitle="Adicionar Conector"
              style={{ marginBottom: 10 + 'px', borderRadius: 5 + 'px' }}
              onClick={() => history.push('/conectores/configuracao/-1')}
            />,
          ]}
        >
          <TableClientes />
        </PageHeader>
      </Body>
    </App>
  );
}
